<template>
  <agent-default>
    <travel-finalization-page channel="agent" />
  </agent-default>
</template>

<script>
import AgentDefault from '@/components/layout/AgentDefault';
import TravelFinalizationPage from '@/components/travel/TravelFinalizationPage';

export default {
  name: 'AgentTravelFinalization',
  components: { AgentDefault, TravelFinalizationPage },
  props: {
    quoteId: { type: [String, Number], default: null },
  },
  metaInfo: { title: 'Travel — Policy Issued' },
};
</script>
